import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import InstallmentReportWidget from '../../../widgets/searchSubProject/InstallmentReportWidget'
import { getSubProjectInstallmentReport } from '../../../redux/actions/subProjectInstallmentReport'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'

export default function InstallmentReport() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const subProjectId = sessionGetItemStr('projectId')

  useEffect(() => {
    console.log('subProjectId => ', subProjectId)
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSubProjectInstallmentReport(subProjectId)
      console.log('res ', _schema)
      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectDep6>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectDep6>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isSubProjectDep6>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />

        <InstallmentReportWidget schema={schema.forms} />
      </SidebarProposal>
    </>
  )

  const mockSchema = {
    header: 'พิมพ์รายงาน',
    subHeader: 'ข้อเสนอโครงการ เด็กฉลาด ขอเบิกงวดเงิน',
    form: {
      title: 'พิมพ์รายงาน',
      values: [
        {
          id: 'xxxxxxx1',
          period: 'งวดที่ 1',
          longTerm: 'ระยะเวลา 01/01/2567 - 30/04/2567',
          budget: 50000,
          statusTxt: 'โอนเงิน',
          statusId: 'xxx1',
          disbursementDate: '01/01/2567',
          report: null,
        },
        {
          id: 'xxxxxxx2',
          period: 'งวดที่ 2',
          longTerm: 'ระยะเวลา 01/05/2567 - 30/08/2567',
          budget: 50000,
          statusTxt: 'โอนเงิน',
          statusId: 'xxx2',
          disbursementDate: '01/05/2567',
          report: [
            {
              id: '',
              text: '1.รายงานความก้าวหน้า (ส.1) งวดที่ 1',
              linkTo: '',
              type: '',
              period: 1,
            },
            {
              id: '',
              text: '2. รายงานการเงิน  (ง.1)',
              linkTo: '',
              type: '',
              period: 1,
            },
          ],
        },
        {
          id: 'xxxxxxx3',
          period: 'งวดที่ 3',
          longTerm: 'ระยะเวลา 01/09/2567 - 31/12/2567',
          budget: 50000,
          statusTxt: 'โอนเงิน',
          statusId: 'xxx3',
          disbursementDate: '01/09/2567',
          report: [
            {
              id: '',
              text: '1.รายงานความก้าวหน้า (ส.3) งวดที่ 2',
              linkTo: '',
              type: '',
              period: 1,
            },
            {
              id: '',
              text: '2. รายงานการเงิน  (ง.3)',
              linkTo: '',
              type: '',
              period: 1,
            },
            {
              id: '',
              text: '3. รายงานฉบับสมบูรณ์',
              linkTo: '',
              type: '',
              period: 1,
            },
          ],
        },
      ],
    },
  }
}
